import { useSelector } from 'react-redux'
import { IconControls } from './IconControls'
import { authSlice } from '@wellesley/auth/authSlice'
import { Button, cn } from '@wellesley/ui'
import { AppsLink } from '@wellesley/router/AppsLink'
import { Loader2, LogIn, UserRoundPlus } from 'lucide-react'
import { UserMenuDropdown } from '@wellesley/user'

const AuthButtons = () => {
  return (
    <div className="flex items-center gap-4">
      <Button asChild variant="secondary">
        <AppsLink to="/signin">
          <LogIn size={20} />
        </AppsLink>
      </Button>
      <Button variant="primary" className="gap-2">
        <UserRoundPlus size={20} />
        <AppsLink to="/signup">Sign up</AppsLink>
      </Button>
    </div>
  )
}
export const Actions = ({ className }: { className?: string }) => {
  const isAuthenticated = useSelector(authSlice.selectors.selectIsAuthenticated)
  const isPending = useSelector(authSlice.selectors.selectPending)

  if (isPending) return <Loader2 className="mr-5 animate-spin" size="24" />

  return isAuthenticated ? (
    <div
      className={cn('flex items-center space-x-2 text-slate-700', className)}
    >
      <IconControls />
      <UserMenuDropdown />
    </div>
  ) : (
    <AuthButtons />
  )
}
